import React from "react";
import "./Header.css";

function Header() {
    return (
        <div className="header">
            <h1>Events & News</h1>
            <h4>Learn, Compete & Grow</h4>
        </div>
    )
}

export default Header;